var timelineBadgeIcons = {
    base: {
        fontSize: "16px",
    },
    variants: {
        position: {},
        size: {},
        variant: {},
    },
    defaultProps: {},
};
var timelineBadge = {
    base: {
        appearance: "none",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
        whiteSpace: "nowrap",
        borderRadius: "100%",
        boxSizing: "border-box",
        fontSize: "16px",
    },
    variants: {
        tone: {
            primary: {
                borderColor: "primary.60",
            },
            secondary: {
                borderColor: "black.40",
            },
            success: {
                borderColor: "success.60",
            },
            warning: {
                borderColor: "warning.60",
            },
            critical: {
                borderColor: "critical.60",
            },
        },
        look: {
            boldSolid: {
                color: "white",
            },
            lightSolid: {
                color: "text",
            },
            lightOutlined: {
                border: "1px solid",
                color: "text",
            },
            dotOutlined: {
                border: "2px solid",
                width: "20px",
                height: "20px",
                backgroundColor: "black.1",
            },
        },
        variant: {
            "boldSolid-primary": {
                backgroundColor: "primary.60",
            },
            "boldSolid-secondary": {
                backgroundColor: "black.40",
            },
            "boldSolid-success": {
                backgroundColor: "success.60",
            },
            "boldSolid-warning": {
                backgroundColor: "warning.60",
            },
            "boldSolid-critical": {
                backgroundColor: "critical.60",
            },
            "lightSolid-primary": {
                backgroundColor: "primary.10",
                color: "primary.60",
            },
            "lightSolid-secondary": {
                backgroundColor: "black.10",
                color: "text",
            },
            "lightSolid-success": {
                backgroundColor: "success.10",
                color: "success.60",
            },
            "lightSolid-warning": {
                backgroundColor: "warning.10",
                color: "warning.60",
            },
            "lightSolid-critical": {
                backgroundColor: "critical.10",
                color: "critical.60",
            },
            "lightOutlined-primary": {
                backgroundColor: "primary.10",
                color: "primary.60",
            },
            "lightOutlined-secondary": {
                backgroundColor: "black.10",
                color: "text",
                borderColor: "black.20",
            },
            "lightOutlined-success": {
                backgroundColor: "success.10",
                color: "success.60",
            },
            "lightOutlined-warning": {
                backgroundColor: "warning.10",
                color: "warning.60",
            },
            "lightOutlined-critical": {
                backgroundColor: "critical.10",
                color: "critical.60",
            },
            "dotOutlined-primary": {
                backgroundColor: "black.1",
                color: "primary.60",
            },
            "dotOutlined-secondary": {
                backgroundColor: "black.1",
                color: "text",
            },
            "dotOutlined-success": {
                backgroundColor: "black.1",
                color: "success.60",
            },
            "dotOutlined-warning": {
                backgroundColor: "black.1",
                color: "warning.60",
            },
            "dotOutlined-critical": {
                backgroundColor: "black.1",
                color: "critical.60",
            },
        },
    },
};
var timelineJoin = {
    base: {
        display: "block",
        flex: 1,
        borderWidth: "0px",
    },
    variants: {
        tone: {
            primary: {
                borderColor: "primary.60",
            },
            secondary: {
                borderColor: "black.20",
            },
            success: {
                borderColor: "success.60",
            },
            warning: {
                borderColor: "warning.60",
            },
            critical: {
                borderColor: "critical.60",
            },
        },
        look: {
            solid: {
                borderStyle: "solid",
            },
            dashed: {
                borderStyle: "dashed",
            },
            dotted: {
                borderStyle: "dotted",
            },
            none: {
                borderStyle: "none",
            },
        },
        orientation: {
            horizontal: {
                height: "0px",
                borderBottomWidth: "4px",
            },
            vertical: {
                width: "0px",
                borderLeftWidth: "4px",
                height: "100%",
            },
        },
    },
    defaultProps: { look: "solid", tone: "primary", orientation: "horizontal" },
};

export { timelineBadge, timelineBadgeIcons, timelineJoin };
//# sourceMappingURL=timeline.js.map
